(function () {
  //
  // ScrollReveal 初期化
  //
  function initScrollReveal() {
    if (typeof ScrollReveal === 'undefined') return;

    var sr = ScrollReveal();

    sr.reveal(".fv-img", {
      delay: 400,
      duration: 1400,
      opacity: 0,
      scale: 0.995,
      easing: 'ease-out',
      reset: false
    });

    sr.reveal(".fv-logo", {
      delay: 800,
      duration: 1400,
      opacity: 0,
      scale: 0.995,
      easing: 'ease-out',
      reset: false
    });

    sr.reveal(".fv-text", {
      delay: 800,
      duration: 1400,
      distance: '12px',
      origin: 'bottom',
      opacity: 0,
      scale: 0.98,
      easing: 'cubic-bezier(0.25, 0.8, 0.25, 1)',
      reset: false
    });

    sr.reveal('.move-title', {
      delay: 400,
      duration: 1800,
      opacity: 0,
      scale: 0.97,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      reset: false
    });

    sr.reveal(".move-elmt", {
      delay: 600,
      duration: 1500,
      distance: '12px',
      origin: 'bottom',
      opacity: 0,
      scale: 0.98,
      easing: 'cubic-bezier(0.25, 0.8, 0.25, 1)',
      reset: false
    });

    sr.reveal(".move-lef", {
      delay: 400,
      duration: 2000,
      distance: '24px',
      origin: 'left',
      opacity: 0,
      scale: 0.98,
      easing: 'cubic-bezier(0.18, 0.89, 0.32, 1.28)',
      reset: false
    });

    sr.reveal('.move-rig', {
      delay: 700,
      duration: 2000,
      distance: '24px',
      origin: 'right',
      opacity: 0,
      scale: 0.98,
      easing: 'cubic-bezier(0.18, 0.89, 0.32, 1.28)',
      reset: false
    });
  }

  //
  // ★ループスライダー + ライトボックス
  //
  function initInspectionSlider() {
    var s = document.getElementById("inspection_slider");
    var t = document.getElementById("inspection_slider_track");
    if (!s || !t) return;

    var sp = 50;
    var MOUSE_THRESH = 5;
    var TOUCH_THRESH = 2;

    var x = 0;
    var cw = 0;
    var lastT = performance.now();
    var down = false;
    var drag = false;
    var hold = false;
    var sx = 0;
    var bx = 0;
    var pid = null;
    var pt = "";
    var lastWasDrag = false;

    var orig = Array.prototype.slice.call(t.children);
    var origImgs = orig
      .map(function (li) { return li.querySelector("img"); })
      .filter(Boolean);

    s.querySelectorAll("img").forEach(function (img) {
      img.setAttribute("draggable", "false");
    });
    s.addEventListener("dragstart", function (e) { e.preventDefault(); });

    function rebuild() {
      Array.prototype.slice.call(t.children).forEach(function (el) {
        if (orig.indexOf(el) === -1) el.remove();
      });
      cw = orig.reduce(function (w, el) {
        return w + el.getBoundingClientRect().width;
      }, 0);
      var need = s.offsetWidth + cw;
      var acc = cw;
      while (acc < need) {
        orig.forEach(function (n) {
          t.appendChild(n.cloneNode(true));
        });
        acc += cw;
      }
    }

    function setX(d) {
      if (cw) d = ((d % cw) + cw) % cw;
      x = d;
      var dpr = window.devicePixelRatio || 1;
      var snapped = Math.round(x * dpr) / dpr;
      t.style.transform = "translate3d(" + (-snapped) + "px,0,0)";
    }

    new ResizeObserver(function () {
      var keep = cw ? (x % cw) : x;
      rebuild();
      setX(keep);
    }).observe(s);

    // 「全部読み込み後」に initInspectionSlider が呼ばれるので、
    // ここで初期構築してOK
    rebuild();
    setX(0);

    function raf(now) {
      var dt = (now - (lastT || now)) / 1000;
      lastT = now;
      if (dt > 1 / 30) dt = 1 / 30;
      if (!hold && cw && sp) setX(x + sp * dt);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    s.style.touchAction = "pan-y";

    s.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      down = true;
      drag = false;
      hold = false;
      lastWasDrag = false;
      sx = e.clientX;
      bx = x;
      pid = e.pointerId;
      pt = e.pointerType;
      if (pt === "touch") {
        try {
          s.setPointerCapture(pid);
        } catch (e2) {}
      }
    }, { passive: true });

    s.addEventListener("pointermove", function (e) {
      if (!down) return;
      if (e.pointerType === "mouse" && e.buttons === 0) return;
      var dx = e.clientX - sx;
      var th = pt === "touch" ? TOUCH_THRESH : MOUSE_THRESH;
      if (!drag && Math.abs(dx) > th) {
        drag = true;
        hold = true;
        s.style.userSelect = "none";
        s.style.webkitUserSelect = "none";
        s.style.touchAction = "none";
      }
      if (drag) {
        setX(bx - dx);
        if (pt === "touch") e.preventDefault();
      }
    }, { passive: false });

    function end(e) {
      if (drag && pt !== "touch") {
        var block = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
        };
        document.addEventListener("click", block, { capture: true, once: true });
      }
      lastWasDrag = !!drag;
      drag = false;
      down = false;
      hold = false;
      lastT = performance.now();
      s.style.removeProperty("user-select");
      s.style.removeProperty("-webkit-user-select");
      s.style.touchAction = "pan-y";
      if (e && e.pointerId != null) {
        try {
          s.releasePointerCapture(e.pointerId);
        } catch (e3) {}
      }
      pid = null;
      pt = "";
    }

    s.addEventListener("pointerup", end, { passive: true });
    s.addEventListener("pointercancel", end, { passive: true });
    s.addEventListener("lostpointercapture", end, { passive: true });
    s.addEventListener("pointerleave", function () {
      if (!drag) down = false;
    }, { passive: true });

    // ライトボックス
    var lbEl = null;
    var lbImg = null;
    var lbIdx = 0;

    function ensureLightbox() {
      if (lbEl) return;
      lbEl = document.createElement("div");
      lbEl.id = "inspection_lightbox";
      lbEl.innerHTML = '' +
        '<div class="ibx-stage">' +
        '  <img class="ibx-img" alt="">' +
        '  <button class="ibx-btn ibx-prev" aria-label="Previous">' +
        '    <img src="https://cdn.shopify.com/s/files/1/0555/5034/5496/files/icon_arrow_lef.png" alt="">' +
        '  </button>' +
        '  <button class="ibx-btn ibx-next" aria-label="Next">' +
        '    <img src="https://cdn.shopify.com/s/files/1/0555/5034/5496/files/icon_arrow_rig.png" alt="">' +
        '  </button>' +
        '  <button class="ibx-btn ibx-close" aria-label="Close">' +
        '    <img src="https://cdn.shopify.com/s/files/1/0555/5034/5496/files/icon_close.png" alt="">' +
        '  </button>' +
        '</div>';
      document.body.appendChild(lbEl);
      lbImg = lbEl.querySelector(".ibx-img");

      var close = function () { lbEl.classList.remove("open"); };

      lbEl.addEventListener("click", function (e) {
        if (e.target === lbEl) close();
      });
      lbEl.querySelector(".ibx-close").addEventListener("click", close);
      lbEl.querySelector(".ibx-prev").addEventListener("click", function (e) {
        e.stopPropagation();
        showAt(lbIdx - 1);
      });
      lbEl.querySelector(".ibx-next").addEventListener("click", function (e) {
        e.stopPropagation();
        showAt(lbIdx + 1);
      });

      document.addEventListener("keydown", function (e) {
        if (!lbEl.classList.contains("open")) return;
        if (e.key === "Escape") lbEl.classList.remove("open");
        if (e.key === "ArrowLeft") showAt(lbIdx - 1);
        if (e.key === "ArrowRight") showAt(lbIdx + 1);
      });
    }

    function showAt(i) {
      if (!origImgs.length) return;
      lbIdx = (i + origImgs.length) % origImgs.length;
      lbImg.src = origImgs[lbIdx].src;
    }

    function openLightboxFrom(target) {
      if (lastWasDrag) return;
      var img = target.closest("#inspection_slider_track img");
      if (!img) return;
      ensureLightbox();
      lbIdx = Math.max(
        0,
        origImgs.findIndex(function (n) { return n.src === img.src; })
      );
      showAt(lbIdx);
      lbEl.classList.add("open");
    }

    s.addEventListener("click", function (e) {
      openLightboxFrom(e.target);
    }, false);

    // 外から速度変えられる用
    window.inspectionSetSpeed = function (v) {
      sp = +v || 0;
    };
  }

  //
  // すべてのリソース読み込み完了後にまとめて初期化
  //
  function initAll() {
    initScrollReveal();
    initInspectionSlider();
  }

  if (document.readyState === 'complete') {
    initAll();
  } else {
    window.addEventListener('load', initAll, { once: true });
  }
})();
